<script setup lang="ts">
const { locales, setLocale, locale } = useI18n();

const currentIcon = computed(() => locales.value.find((l) => l.code === locale.value)?.icon || '');
const items = ref(
  locales.value.map((locale) => ({
    label: locale.name,
    icon: locale.icon,
    value: locale.code,
  })),
);
const changeLocale = (newLocale: 'en' | 'de' | 'fr') => {
  setLocale(newLocale);
};
</script>

<template>
  <USelect :items="items" :model-value="locale" :icon="currentIcon" @update:model-value="changeLocale">
    <template #default>&nbsp;</template>
    <template #item-label>&nbsp;</template>
  </USelect>
</template>
